import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function ClassifiedListing() {
  const [classifieds, setClassifieds] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredClassifieds, setFilteredClassifieds] = useState([]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  // Fetch data
  useEffect(() => {
    axios.get('https://backend-zkgn.onrender.com/api/classified')
      .then(res => {
        setClassifieds(res.data);
        setFilteredClassifieds(res.data);
      })
      .catch(err => {
        console.error("Error fetching classified data:", err);
      });
  }, []);

  // Search functionality
  useEffect(() => {
    const results = classifieds.filter(item =>
      item.classified_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredClassifieds(results);
    setCurrentPage(1); // Reset to first page after search
  }, [searchTerm, classifieds]);

  // Pagination logic
  const totalPages = Math.ceil(filteredClassifieds.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredClassifieds.slice(indexOfFirst, indexOfLast);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const goToPreviousPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  // Compact pagination theme
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }
    return pages;
  };

  return (
    <div className="container-fluid my-4">
      {/* Search Bar */}
      <div className="row mb-4">
        <div className="col-md-12">
          <input
            type="text"
            className="form-control"
            placeholder="Search classifieds by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Count */}
      <div className="text-left mb-3">
        <h5 className="fw-bold text-tertiry">
          <strong>{filteredClassifieds.length}</strong> Classifieds Found
        </h5>
      </div>

      {/* Classified Cards */}
      <div className="row">
        {currentItems.map((item, index) => (
          <div className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4" key={index}>
            <div className="classified-card p-3 border rounded text-center bg-light shadow-sm">
              <Link
                to={`/classified/${item.classified_id}`}
                className="classified-link text-decoration-none text-dark fw-semibold"
              >
                {item.classified_name}
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* Compact Pagination */}
      {totalPages > 1 && (
        <nav className="d-flex justify-content-center mt-4">
          <ul className="pagination pagination-sm flex-wrap shadow-sm">
            {/* Previous */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={goToPreviousPage}>
                ← Previous
              </button>
            </li>

            {getPageNumbers().map((page, index) =>
              page === "..." ? (
                <li key={index} className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              ) : (
                <li
                  key={index}
                  className={`page-item ${currentPage === page ? "active" : ""}`}
                >
                  <button className="page-link" onClick={() => paginate(page)}>
                    {page}
                  </button>
                </li>
              )
            )}

            {/* Next */}
            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={goToNextPage}>
                Next →
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
}

export default ClassifiedListing;
